import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {AuthActionTypes, LogoutAction} from './auth.actions';

import {map, switchMap, tap} from 'rxjs/operators';
import {AuthService} from '../services/auth.lib.service';
import { ClearStateAction, GoAction, GoSignInFromNoHttpAuthAction } from 'libs/tm-common/src/lib/store/actions/actions';

@Injectable({
	providedIn: 'root'
})
export class AuthEffects {
	private actions$ = inject(Actions);
	private authService = inject(AuthService);

	logout$ = createEffect(() => this.actions$.pipe(
		ofType<LogoutAction>(AuthActionTypes.LogoutAction),
		tap(() => {
			this.authService.logout()
				.subscribe({
					error: (e) => console.error(e),
					complete: () => console.info('Logged out successfully')
				});
		}),
		switchMap(() => [
			new ClearStateAction(),
			new GoAction({ path: ['/signin'] })
		])

	));

	noHttpsAuth$ = createEffect(() => this.actions$.pipe(
		ofType<LogoutAction>(AuthActionTypes.NoHttpAuthAction),
		map(() => new GoSignInFromNoHttpAuthAction())
	));
}
